/** 
* 自动生成文件，请勿修改 
* @name: 支付:外协支付申请审批流程设置
* @description: 外协支付申请审批流程设置（三期新增）
* @create: 2024/1/11 下午4:25:21
* @swagger: 2.0
* 合计:7条
*/ 
 
import APIObject from "../utils/APIObject.js" 
const payAudit = { 
	/** 1 summary:单条数据查询	method:post */ 
	queryOne : new APIObject("/api/payAudit/queryOne.do"), 
	/** 2 summary:分页查询	method:post */ 
	queryPage : new APIObject("/api/payAudit/queryPage.do"), 
	/** 3 summary:保存/修改	method:post */ 
	saveOrUpd : new APIObject("/api/payAudit/saveOrUpd.do"), 
	/** 4 summary:批量保存/修改	method:post */ 
	batchSaveOrUpd : new APIObject("/api/payAudit/batchSaveOrUpd.do"), 
	/** 5 summary:单条删除	method:post */ 
	delete : new APIObject("/api/payAudit/delete.do"), 
	/** 6 summary:所有数据查询	method:post */ 
	queryAll : new APIObject("/api/payAudit/queryAll.do"), 
	/** 7 summary:批量删除	method:post */ 
	batchDelete : new APIObject("/api/payAudit/batchDelete.do"), 
};
export default payAudit;